import BMap from 'BMap'
import BMapLib from 'BMapLib'
class MapDrawer {
  constructor (map, overlays) {
    // console.log(1)
    this.map = map
    this.overlays = overlays
    this.drawData = ''
    // 定义颜色样式
    this.styleOptions = {
      //边线颜色。
      strokeColor:"red",
      //填充颜色。当参数为空时，圆形将没有填充效果   
      fillColor:"red",
      //边线的宽度，以像素为单位    
      strokeWeight: 3,
      //边线透明度，取值范围0 - 1     
      strokeOpacity: 0.8,
      //填充的透明度，取值范围0 - 1	   
      fillOpacity: 0.6,
      //边线的样式，solid或dashed    
      strokeStyle: 'solid'
    }
    // 1. 创建绘制工具
    //实例化鼠标绘制工具
    this.drawingManager = new BMapLib.DrawingManager(this.map, {
      //是否开启绘制模式
      isOpen: true,
      //是否显示工具栏
      enableDrawingTool: true,
      drawingToolOptions: {
          //位置
          // anchor: BMAP_ANCHOR_TOP_LEFT, 
          //偏离值
          offset: new BMap.Size(5, 5), 
          // 只能画圆，线条，多边形
          drawingModes: [
            BMAP_DRAWING_CIRCLE, 
            // BMAP_DRAWING_POLYLINE,
            BMAP_DRAWING_POLYGON
          ]
      },
      circleOptions: this.styleOptions, //圆的样式
      // polylineOptions: this.styleOptions, //线的样式
      polygonOptions: this.styleOptions, //多边形的样式
    })
  }
  getDrawingManager () {
    return this.drawingManager
  }
  exitDraw () {
    // this.drawingManager._opts.enableDrawingTool = false
    // 重新生成drawingModes
    this.drawingManager = new BMapLib.DrawingManager(this.map, {
      //是否开启绘制模式
      isOpen: false,
      //是否显示工具栏
      enableDrawingTool: false
    })
  }
}
export default MapDrawer